import React from "react";
import { useParams } from "react-router-dom";
import { MessageSquare } from "lucide-react";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";
import ErrorBoundary from "../../components/ErrorBoundary/";
import { i18n } from "../../translate/i18n";

const Chat = () => {
  const { ticketId } = useParams();

  return (
    <div className="flex h-full overflow-hidden bg-slate-100 dark:bg-slate-950 p-2 gap-2">
      {/* Ticket list panel */}
      <div
        className={`
          flex flex-col bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden
          ${ticketId ? "hidden md:flex md:w-80 lg:w-96 flex-shrink-0" : "w-full md:w-80 lg:w-96 md:flex-none"}
        `}
      >
        <ErrorBoundary>
          <TicketsManager />
        </ErrorBoundary>
      </div>

      {/* Chat panel */}
      <div
        className={`
          flex-1 flex flex-col bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm overflow-hidden
          ${ticketId ? "flex" : "hidden md:flex"}
        `}
      >
        {ticketId ? (
          <ErrorBoundary resetKey={ticketId}>
            <Ticket />
          </ErrorBoundary>
        ) : (
          <div className="hidden md:flex flex-col items-center justify-center h-full gap-4 text-center px-6">
            <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-indigo-600 to-indigo-800 flex items-center justify-center shadow-lg">
              <MessageSquare className="w-10 h-10 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-1">
                Bienvenido a Voxia
              </h2>
              <p className="text-slate-500 dark:text-slate-400 text-sm max-w-sm">
                {i18n.t("chat.noTicketMessage")}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
